import React from "react";
import { Switch, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

interface BooleanToggleCellProps {
  checked: boolean;
  disabled?: boolean;
  loading?: boolean;
  onChange: (checked: boolean) => void;
  ariaLabel?: string;
}

/**
 * Touch-friendly boolean toggle using Ant Design Switch.
 * Used in RelationshipCardView for mobile-optimized attendance-style UX.
 * Switch is 44x22px by default — meets minimum touch target guidelines.
 */
export const BooleanToggleCell: React.FC<BooleanToggleCellProps> = ({
  checked,
  disabled = false,
  loading = false,
  onChange,
  ariaLabel,
}) => {
  if (loading) {
    return (
      <Spin
        indicator={<LoadingOutlined style={{ fontSize: 16 }} spin />}
        size="small"
      />
    );
  }

  return (
    <Switch
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      aria-label={ariaLabel}
    />
  );
};

export default BooleanToggleCell;
